import useRequest, {
    RequestFn,
    RequestKeys,
} from 'app/hooks/useRequest'

import longTermLeasePositionRequests from '../LongTermLeasePosition.requsts'

const useGetLongTermLeasePosition = ({
    longTermLeasePositionId,
}: {
    longTermLeasePositionId: number,
}) => {
    return useRequest({
        key: RequestKeys.getLongTermLeasePosition,
        params: {
            longTermLeasePositionId,
        },
        requestFunc: RequestFn.getEntity(longTermLeasePositionRequests.get),
        enabled: Boolean(longTermLeasePositionId),
    })
}

export default useGetLongTermLeasePosition
